import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const MetodoDepreciacionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-numeroAutorizacion', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MET. DEPREC.' htmlFor='input-metodoDepreciacion' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='metodoDepreciacion'>
          {({ field }) => (
            <Form.Select
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-metodoDepreciacion'
              onKeyDown={onKeyDown}
            >
              <option value=''>Seleccionar</option>
              <option value='LINEAL'>Lineal</option>
              <option value='ACELERADA'>Acelerada</option>
              <option value='UNIDAD_PRODUCCION'>Unidad Producción</option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MetodoDepreciacionFormGroup)
